
//----------------------------------------------------------
// Generated file, DO NOT EDIT.
// To regenerate this file, run "GenerateConstants.cmd" .

// Generated data for the following assemblies:
// Microsoft.TeamFoundation.Build.WebApi
//----------------------------------------------------------


export module BuildResourceIds {
    export var Builds = "0cd358e1-9217-4d94-8269-1c1ee6f93dcf";
    export var Definitions = "dbeaf647-6167-421a-bda9-c9327b25e2e6";
    export var Requests = "de3e9770-c7ef-4697-983e-f4b5bab3c016";
    export var Details = "9f094d42-b41c-4920-95aa-597581a79821";
    export var Queues = "09f2a4b8-08c9-4991-85c3-d698937568be";
    export var Qualities = "82fba9f8-4198-4ab6-b719-6a363880c19e";
    export var AzureDeployments = "7985e151-1f22-4344-9173-1a663ee1eb4d";
    export var AzureDeploymentDefinitions = "2f00bd4f-422d-417c-b429-f588ded6486f";
    export var AzureDeploymentEnvironments = "32696366-f57b-4529-aec4-61673d4c23c6";
    export var AzureSubscriptions = "0524c91b-a145-413c-89eb-b3342b6826a4";
    export var Content = "29ddf488-1550-4956-977c-7706034d781d";
    export var ProcessTemplates = "f188fc3e-967c-4290-b9e1-a2df5b7b6abc";
    export var Drop = "051feb46-15bd-4067-be5a-6c314c8de59e";
    export var Agents = "b27af3f2-aa0c-4ca9-85cf-493b25fe12db";
    export var BuildServiceHosts = "83db2197-1fa4-4097-90d3-bd408adc4bf9";
    export var Symbols = "e251c89a-e968-4284-a739-6224e3dae39d";
    export var TestResults = "29570641-fe78-46de-a13a-d7bc3d1d20a1";
    export var Label = "7edd2690-527a-41f5-9ffa-2515e9cf22c6";
    /**
    * Service area for all build REST endpoints
    */
    export var AreaId = "965220D5-5BB9-42CF-8D67-9B146DF2A5A4";
    export var AreaName = "Build";
    export var BuildsLocationString = "{0CD358E1-9217-4D94-8269-1C1EE6F93DCF}";
    export var BuildsResource = "Builds";
    export var DefinitionsLocationString = "{dbeaf647-6167-421a-bda9-c9327b25e2e6}";
    export var DefinitionsResource = "Definitions";
    export var RequestsLocationString = "{DE3E9770-C7EF-4697-983E-F4B5BAB3C016}";
    export var RequestsResource = "Requests";
    export var DetailsLocationString = "{9F094D42-B41C-4920-95AA-597581A79821}";
    export var DetailsResource = "Details";
    export var QueuesLocationString = "{09F2A4B8-08C9-4991-85C3-D698937568BE}";
    export var QueuesResource = "Queues";
    export var QualitiesLocationString = "{82FBA9F8-4198-4AB6-B719-6A363880C19E}";
    export var QualitiesResource = "Qualities";
    export var AzureDeploymentsLocationString = "{7985E151-1F22-4344-9173-1A663EE1EB4D}";
    export var AzureDeploymentsResource = "Deployments";
    export var AzureDeploymentDefinitionsLocationString = "{2F00BD4F-422D-417C-B429-F588DED6486F}";
    export var AzureDeploymentDefinitionsResource = "DeploymentDefinitions";
    export var AzureDeploymentEnvironmentsLocationString = "{32696366-F57B-4529-AEC4-61673D4C23C6}";
    export var AzureDeploymentEnvironmentsResource = "DeploymentEnvironments";
    export var AzureSubscriptionsLocationString = "{0524C91B-A145-413C-89EB-B3342B6826A4}";
    export var AzureSubscriptionsResource = "AzureSubscriptions";
    export var ContentLocationString = "{29DDF488-1550-4956-977C-7706034D781D}";
    export var ContentResource = "Content";
    export var ProcessTemplatesLocationString = "{F188FC3E-967C-4290-B9E1-A2DF5B7B6ABC}";
    export var ProcessTemplatesResource = "ProcessTemplates";
    export var DropLocationString = "{051FEB46-15BD-4067-BE5A-6C314C8DE59E}";
    export var DropResource = "Drop";
    export var AgentsLocationString = "{B27AF3F2-AA0C-4CA9-85CF-493B25FE12DB}";
    export var AgentsResource = "Agents";
    export var BuildServiceHostsLocationString = "{83DB2197-1FA4-4097-90D3-BD408ADC4BF9}";
    export var BuildServiceHostsResource = "Servers";
    export var SymbolsLocationString = "{E251C89A-E968-4284-A739-6224E3DAE39D}";
    export var SymbolsResource = "Symbols";
    export var TestResultsLocationString = "{29570641-FE78-46DE-A13A-D7BC3D1D20A1}";
    export var TestResultsResource = "TestResults";
    export var LabelLocationString = "{7EDD2690-527A-41F5-9FFA-2515E9CF22C6}";
    export var LabelResource = "Label";
}

